/*
  Zenless Zone Zero Catalog - Full UI Integration
  - Keeps all controls, buttons, and toast from the template
  - Populates #filters with Zenless Zone Zero data only
  - Supports selection, count badge, clear, and search button logic
  - API endpoint: http://118.89.84.40/index/index/username_list.html?item_id=281&ascription_id=10338&page=1
  - Uses Vercel proxy for CORS
  - Response shape: { pages, data: [ { role_img: [ { id, name, code, img, ... }, ... ] } ] }
*/
(function () {
  /* ====== API Sources Declaration ====== */
  const API_SOURCES = {
    'zzz01_chars': { name: 'ZZZ01 Characters API', enabled: true },
    'zzz01_deck': { name: 'ZZZ01 Deck Search API', enabled: true }
  };

  const escapeHtml = s => String(s || '').replace(/[&<>"']|'/g, m => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[m]));
  const ZZZ01_ALL_CHARS_API = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/zzz01-proxy?action=list';
  const ZZZ01_DECK_API = 'https://nodejs-serverless-function-express-delta-ten-11.vercel.app/api/zzz01-proxy';

  let selected = {};
  let characterList = [];

  // Settings & Translations Initialization
  let zzzSettings = { translations_json: '{}', images_json: '{}', api_toggles: {} };
  try {
    const el = document.getElementById('catalog-zenlesszonezero-settings');
    if (el) zzzSettings = JSON.parse(el.textContent);
  } catch (e) {
    console.error('[ZZZ] Failed to parse settings:', e);
    zzzSettings = { translations_json: '{}', images_json: '{}', api_toggles: {} };
  }

  // console.log('[ZZZ] Raw settings from Liquid:', zzzSettings);
  // console.log('[ZZZ] API toggles received:', zzzSettings.api_toggles);

  // Override API_SOURCES enabled state from admin settings
  if (zzzSettings.api_toggles) {
    Object.keys(API_SOURCES).forEach(apiId => {
      const oldState = API_SOURCES[apiId].enabled;
      if (zzzSettings.api_toggles.hasOwnProperty(apiId)) {
        API_SOURCES[apiId].enabled = zzzSettings.api_toggles[apiId] === true;
        // console.log(`[ZZZ] API '${apiId}': ${oldState} → ${API_SOURCES[apiId].enabled} (admin setting: ${zzzSettings.api_toggles[apiId]})`);
      }
    });
  }

  // console.log('[ZZZ] ═══════════════════════════════════════════');
  // console.log('[ZZZ] FINAL API SOURCES STATUS:');
  Object.entries(API_SOURCES).forEach(([id, api]) => {
    // console.log(`[ZZZ]   ${id}: ${api.enabled ? '✅ ENABLED' : '❌ DISABLED'} (${api.name})`);
  });
  // console.log('[ZZZ] ═══════════════════════════════════════════');

  const enableApiCalls = API_SOURCES.zzz01_chars.enabled && API_SOURCES.zzz01_deck.enabled;

  let nameTranslations = {}, nameTranslationsMap = {};
  try {
    nameTranslations = JSON.parse(zzzSettings.translations_json || '{}');
    Object.entries(nameTranslations).forEach(([key, val]) => {
      key.split('|').map(k => k.trim()).forEach(k => { if (k) nameTranslationsMap[k] = val; });
    });
    // console.log('[ZZZ] Translations loaded:', nameTranslationsMap);
    // console.log('[ZZZ] Total translation entries:', Object.keys(nameTranslationsMap).length);
  } catch (e) {
    console.warn('[ZZZ] Failed to parse translations:', e);
    nameTranslations = {};
    nameTranslationsMap = {};
  }

  let customImages = {}, customImagesMap = {};
  try {
    customImages = JSON.parse(zzzSettings.images_json || '{}');
    Object.entries(customImages).forEach(([key, val]) => {
      key.split('|').map(k => k.trim()).forEach(k => { if (k) customImagesMap[k] = val; });
    });
    // console.log('[ZZZ] Custom images loaded:', Object.keys(customImagesMap).length, 'entries');
  } catch (e) {
    console.warn('[ZZZ] Failed to parse custom images:', e);
    customImages = {};
    customImagesMap = {};
  }

  // Translation helper function
  const translateName = name => {
    const translated = nameTranslationsMap[name] || name;
    if (translated !== name) {
      // console.log(`[ZZZ] Translated: "${name}" → "${translated}"`);
    }
    return translated;
  };

  // Custom image helper function
  const getCustomImage = name => customImagesMap[name] || null;

  // Server translation helper
  const translateServer = (district) => {
    const serverMap = {
      '美洲': 'America',
      '欧洲': 'Europe',
      '亚洲': 'Asia',
      '国际服': 'Global'
    };
    return serverMap[district] || district;
  };

  // ID obfuscation logic (same as chushi-app.js)
  function privateToPublicID(privateID) {
    if (!privateID) return '';
    return GachaUtils.obfuscateId(privateID, 'ZZZ');
  }

  // Sort characters: regular characters first, then weapons/bangboos (with "礼装" or similar prefix)
  const sortCharacters = (chars) => {
    return chars.sort((a, b) => {
      const aIsWeapon = a.name.includes('礼装') || a.name.includes('音擎');
      const bIsWeapon = b.name.includes('礼装') || b.name.includes('音擎');

      // If one is weapon and the other isn't, non-weapon comes first
      if (aIsWeapon && !bIsWeapon) return 1;
      if (!aIsWeapon && bIsWeapon) return -1;

      // If both are same type, maintain original order
      return 0;
    });
  };

  // Pagination state
  let allFilteredAccounts = []; // All accounts currently displayed
  let currentPage = 0; // Last page we fetched
  let totalPages = 0; // Total pages available from API
  let currentSearchParams = null; // Store search params for continuation
  let currentSelectedServer = ''; // Store selected server for continuation
  let isLoadingMore = false; // Prevent multiple simultaneous loads
  const ACCOUNTS_PER_BATCH = 5; // Show 5 accounts per batch

  function updateSelectedUI() {
    const totalCount = Object.values(selected).reduce((sum, sel) => sum + (sel.count || 0), 0);
    const selectedCountEl = document.querySelector("#selectedCount");
    if (selectedCountEl) selectedCountEl.textContent = totalCount;
  }

  // Scroll to results section for better UX
  const scrollToResults = () => document.querySelector("#results")?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  function updateThumbDisplay(thumb, code) {
    const count = selected[code]?.count || 0;
    const existingBadge = thumb.querySelector('.count-badge');
    if (count > 0) {
      thumb.classList.add('selected');
      if (existingBadge) {
        existingBadge.textContent = count;
      } else {
        const badge = document.createElement('div');
        badge.className = 'count-badge';
        badge.textContent = count;
        thumb.querySelector('.thumb-img-container').appendChild(badge);
      }
    } else {
      thumb.classList.remove('selected');
      if (existingBadge) existingBadge.remove();
    }
  }
  function clearSelection() {
    selected = {};
    document.querySelectorAll('.thumb').forEach(thumb => {
      thumb.classList.remove('selected');
      const badge = thumb.querySelector('.count-badge');
      if (badge) badge.remove();
    });
    updateSelectedUI();
  }
  function showToast(message, duration = 3000) {
    const toast = document.querySelector("#toast");
    if (!toast) return;

    // Update toast message if provided
    if (message) {
      const toastText = toast.querySelector('.toast-content span');
      if (toastText) toastText.textContent = message;
    }

    toast.classList.remove('hidden');
    toast.offsetHeight;
    toast.classList.add('show');

    if (duration > 0) {
      setTimeout(() => { toast.classList.remove('show'); setTimeout(() => toast.classList.add('hidden'), 300); }, duration);
    }
  }

  function hideToast() {
    const toast = document.querySelector("#toast");
    if (!toast) return;
    toast.classList.remove('show');
    setTimeout(() => toast.classList.add('hidden'), 300);
  }
  function copyToClipboard(text) {
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(text).then(() => showToast('ID copied! Please share this with customer service to get price quotation.')).catch(() => fallbackCopy(text));
    } else fallbackCopy(text);
  }
  function fallbackCopy(text) {
    const ta = document.createElement('textarea');
    ta.value = text; ta.style.cssText = 'position:fixed;left:-9999px';
    document.body.appendChild(ta); ta.select();
    try { document.execCommand('copy'); showToast('ID copied! Please share this with customer service to get price quotation.'); } catch (e) { console.error('Copy failed:', e); }
    document.body.removeChild(ta);
  }
  function renderFilterUI() {
    const container = document.querySelector("#filters");
    if (!container) return;
    container.innerHTML = '';
    if (!characterList.length) {
      container.innerHTML = '<div class="no-data">No character data.</div>';
      return;
    }
    characterList.forEach(char => {
      const thumb = document.createElement('div');
      thumb.className = 'thumb';
      thumb.dataset.code = char.code;

      // Apply translation and custom image
      const displayName = translateName(char.name);
      const customImg = getCustomImage(char.name);
      const displayImg = customImg || char.img;

      // console.log(`[ZZZ] Rendering character: Original="${char.name}", Translated="${displayName}", CustomImg=${customImg ? 'Yes' : 'No'}`);

      thumb.innerHTML = `
        <div class="thumb-img-container">
          <img alt="${escapeHtml(displayName)}" src="${escapeHtml(displayImg)}" loading="lazy"/>
        </div>
        <div class="label">${escapeHtml(displayName)}</div>
      `;
      thumb.onclick = () => {
        const code = thumb.dataset.code;
        if (selected[code]) {
          selected[code].count++;
        } else {
          selected[code] = { count: 1, name: displayName, img: displayImg, originalName: char.name };
        }
        updateThumbDisplay(thumb, code);
        updateSelectedUI();
      };
      container.appendChild(thumb);
    });
    updateSelectedUI();
  }
  function loadResources() {
    // Show API status banner if disabled
    const disabledApis = Object.entries(API_SOURCES).filter(([id, api]) => !api.enabled).map(([id, api]) => api.name);
    if (disabledApis.length > 0) {
      // console.log('[ZZZ] Some APIs are disabled - showing warning banner');
      const searchSection = document.querySelector("#zzz01");
      if (searchSection) {
        const banner = document.createElement('div');
        banner.style.cssText = 'background: #fef3c7; border: 2px solid #f59e0b; border-radius: 8px; padding: 12px 16px; margin: 16px 0; color: #92400e; font-weight: 500; text-align: center;';
        banner.innerHTML = `⚠️ API calls are currently disabled. Search functionality is temporarily unavailable. Please contact Gachamacha support for assistance.`;
        searchSection.insertBefore(banner, searchSection.firstChild);
      }
    }

    if (!API_SOURCES.zzz01_chars.enabled) {
      // console.log('[ZZZ] ❌ Skipping ZZZ01 Characters API (disabled)');
      const container = document.querySelector("#filters");
      if (container) container.innerHTML = '<div class="no-data">⚠️ API calls are currently disabled.<br><br>Please contact Gachamacha support for assistance.</div>';
      return;
    }

    // console.log('[ZZZ] ✅ Loading ZZZ01 Characters API');
    fetch(ZZZ01_ALL_CHARS_API)
      .then(r => r.json())
      .then(payload => {
        characterList = Array.isArray(payload.characters) ? payload.characters : [];
        // console.log(`[ZZZ] Loaded ${characterList.length} characters from all-characters API`);

        // Sort: Characters first, then weapons
        characterList = sortCharacters(characterList);
        const weaponCount = characterList.filter(c => c.name.includes('礼装') || c.name.includes('音擎')).length;
        // console.log(`[ZZZ] Sorted: ${characterList.length - weaponCount} characters, ${weaponCount} weapons`);

        renderFilterUI();
      })
      .catch(err => {
        console.error("ZZZ filter load failed:", err);
        const container = document.querySelector("#filters");
        if (container) container.innerHTML = '<div class="no-data">Failed to load character list.</div>';
      });
  }

  // Fetch pages incrementally until we have enough filtered results
  async function fetchNextBatch(baseParams, selectedCodes, selectedServer, targetCount, isLoadMore = false) {
    const filteredAccounts = [];
    let lastPage = currentPage;
    let totalPagesAvailable = 0;
    let checkedPages = 0;
    const maxPagesToCheck = 10; // Safety limit to prevent infinite loops
    const resultsEl = document.querySelector("#results");

    // console.log(`=== Fetching next batch (target: ${targetCount} accounts, starting from page ${lastPage + 1}) ===`);

    while (filteredAccounts.length < targetCount && checkedPages < maxPagesToCheck) {
      lastPage++;
      checkedPages++;

      // Update loading message with progress
      if (resultsEl) {
        if (isLoadMore) {
          // For load more, append loading indicator at the bottom
          let loadingDiv = resultsEl.querySelector('#loadMoreLoading');
          if (!loadingDiv) {
            loadingDiv = document.createElement('div');
            loadingDiv.id = 'loadMoreLoading';
            loadingDiv.className = 'loading';
            resultsEl.appendChild(loadingDiv);
          }
          loadingDiv.textContent = `🔍 Searching page ${lastPage}... Found ${filteredAccounts.length} matching account(s) so far`;
        } else {
          // For initial search, replace entire content
          resultsEl.innerHTML = `<div class="loading">🔍 Searching page ${lastPage}... Found ${filteredAccounts.length} matching account(s) so far</div>`;
        }
      }

      const pageParams = new URLSearchParams(baseParams);
      pageParams.set('page', lastPage.toString());
      const pageUrl = `${ZZZ01_DECK_API}?${pageParams.toString()}`;

      // console.log(`Fetching page ${lastPage}...`);

      try {
        const response = await fetch(pageUrl);

        if (!response.ok) {
          console.error(`Page ${lastPage} HTTP error: ${response.status} ${response.statusText}`);

          // Handle timeout errors specifically
          if (response.status === 504) {
            const errorData = await response.json().catch(() => ({ error: 'Gateway Timeout' }));
            console.error('Timeout error:', errorData);
            throw new Error('TIMEOUT: ' + (errorData.error || 'The game server is not responding'));
          }

          const errorText = await response.text();
          console.error('Error response:', errorText);
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        // console.log(`Page ${lastPage} raw response:`, data);

        // Store total pages from first response
        if (totalPagesAvailable === 0) {
          totalPagesAvailable = parseInt(data.pages) || 1;
          // console.log(`Total pages available: ${totalPagesAvailable}`);
        }

        const pageAccounts = data.data || [];
        // console.log(`Page ${lastPage}: ${pageAccounts.length} accounts fetched`);
        // console.log(`Page ${lastPage} first account sample:`, pageAccounts[0]);

        // Filter accounts that have ALL selected characters AND match selected server
        // Also filter out fake accounts with duplicate 浅羽悠真
        const matchingAccounts = pageAccounts.filter(account => {
          const accountCodes = account.user_role || [];
          const hasAllChars = selectedCodes.every(code => accountCodes.includes(code));

          // Check server filter (if a server is selected)
          const matchesServer = !selectedServer || account.district === selectedServer;

          // Check for duplicate 浅羽悠真 (fake account indicator)
          const roleImgs = account.role_img || [];
          const asabaYuCount = roleImgs.filter(char => char.name === '浅羽悠真').length;
          const isFakeAccount = asabaYuCount > 1;

          if (isFakeAccount) {
            // console.log(`[ZZZ Filter] ❌ Filtered out fake account ${account.code}: duplicate`);
          }

          if (!matchesServer && hasAllChars && !isFakeAccount) {
            // console.log(`[ZZZ Filter] ❌ Filtered out account ${account.code}: Server is "${account.district}" (selected: "${selectedServer}")`);
          }

          // Log all accounts being checked
          if (hasAllChars && !isFakeAccount && matchesServer) {
            // console.log(`[ZZZ Filter] ✓ Account ${account.code} PASSED all filters (Server: ${account.district})`);
          }

          return hasAllChars && !isFakeAccount && matchesServer;
        });

        // console.log(`Page ${lastPage}: ${matchingAccounts.length} matching accounts after filter`);
        filteredAccounts.push(...matchingAccounts);

        // Stop if we've reached the last page
        if (lastPage >= totalPagesAvailable) {
          // console.log('Reached last page');
          break;
        }

        // Stop if we have enough results
        if (filteredAccounts.length >= targetCount) {
          // console.log(`Target reached: ${filteredAccounts.length} >= ${targetCount}`);
          break;
        }
      } catch (err) {
        console.error(`Error fetching page ${lastPage}:`, err);

        // If it's a timeout, throw it up to be handled by the caller
        if (err.message && err.message.includes('TIMEOUT')) {
          throw err;
        }

        // For other errors, stop pagination but don't throw
        break;
      }
    }

    return {
      filteredAccounts: filteredAccounts,
      lastPage: lastPage,
      totalPages: totalPagesAvailable,
      hasMore: lastPage < totalPagesAvailable
    };
  }

  async function performSearch() {
    const resultsEl = document.querySelector("#results");
    if (!resultsEl) return;
    if (!Object.keys(selected).length) {
      resultsEl.innerHTML = '<div class="no-data">No selection.</div>';
      return;
    }

    // Check if API calls are disabled
    if (!enableApiCalls) {
      // console.log('[ZZZ] API calls are disabled via admin settings');
      resultsEl.innerHTML = '<div class="no-data">⚠️ API calls are currently disabled.<br><br>Please contact Gachamacha support for assistance.</div>';
      showToast('⚠️ API calls are currently disabled', 3000);
      return;
    }

    // console.log('[ZZZ] ═══════════════════════════════════════════');
    // console.log('[ZZZ] SEARCH: Checking API states...');
    // console.log(`[ZZZ] ZZZ01 Deck API: enabled=${API_SOURCES.zzz01_deck.enabled}`);

    if (!API_SOURCES.zzz01_deck.enabled) {
      // console.log('[ZZZ] ❌ Skipping ZZZ01 Deck API (disabled)');
      resultsEl.innerHTML = '<div class="no-data">⚠️ API calls are currently disabled.<br><br>Please contact Gachamacha support for assistance.</div>';
      return;
    }

    // console.log('[ZZZ] ✅ Querying ZZZ01 Deck API');
    // console.log('[ZZZ] ═══════════════════════════════════════════');

    // Disable search button during search with spinner
    const searchBtn = document.querySelector("#searchBtn");
    if (searchBtn) {
      searchBtn.disabled = true;
      searchBtn.innerHTML = '<span style="display: inline-flex; align-items: center; gap: 8px;"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="animation: spin 1s linear infinite;"><circle cx="12" cy="12" r="10" opacity="0.25"></circle><path d="M12 2a10 10 0 0 1 10 10" stroke-linecap="round"></path></svg>Searching...</span>';
    }

    // Show toast notification
    showToast('🔍 Searching for matching accounts... Please wait.', 0); // 0 = don't auto-hide

    resultsEl.innerHTML = '<div class="loading">🔍 Searching for matching accounts...</div>';

    // Log selected characters
    // console.log('=== SEARCH DEBUG ===');
    // console.log('Selected characters:', Object.keys(selected).map(code => {
    // const char = characterList.find(c => c.code === code);
    // return {
    //   code: code,
    //   name: char?.name || 'Unknown',
    //   count: selected[code].count,
    //   id: char?.id || 'Unknown'
    // };
    // }));

    // Get selected server
    const serverSelect = document.querySelector('#serverSelect');
    const selectedServer = serverSelect ? serverSelect.value : '';

    // Build base query parameters with role[CODE]=count format
    const baseParams = new URLSearchParams({
      item_id: '281',
      ascription_id: '10338',
      District: selectedServer  // Add District parameter
    });

    // console.log(`Selected server: ${selectedServer || 'All Servers'} (District=${selectedServer})`);

    // Add selected characters as role[CODE]=count
    Object.keys(selected).forEach(code => {
      baseParams.append(`role[${code}]`, selected[code].count);
      // console.log(`Adding parameter: role[${code}] = ${selected[code].count}`);
    });

    try {
      // Reset state for new search
      currentPage = 0;
      allFilteredAccounts = [];
      currentSearchParams = baseParams;
      currentSelectedServer = selectedServer; // Store for load more

      // Fetch pages incrementally until we have 5 filtered results
      const selectedCodes = Object.keys(selected);
      // console.log('Selected character codes for filtering:', selectedCodes);

      resultsEl.innerHTML = '<div class="loading">🔍 Searching for matching accounts...</div>';

      const result = await fetchNextBatch(baseParams, selectedCodes, selectedServer, ACCOUNTS_PER_BATCH);

      if (result.filteredAccounts.length === 0) {
        // Hide searching toast and show appropriate message
        hideToast();
        if (result.lastPage === 0) {
          resultsEl.innerHTML = '<div class="no-data">Search failed. The API may be experiencing issues. Please try again.</div>';
          setTimeout(() => showToast('❌ Search failed. The API may be experiencing issues.', 3000), 300);
        } else {
          resultsEl.innerHTML = '<div class="no-data">No matching accounts found.</div>';
          setTimeout(() => showToast('ℹ️ No matching accounts found.', 3000), 300);
        }
        return;
      }

      // Store results
      allFilteredAccounts = result.filteredAccounts;
      currentPage = result.lastPage;
      totalPages = result.totalPages;

      // console.log(`Found ${result.filteredAccounts.length} matching accounts after checking ${result.lastPage} pages`);

      // Render results
      renderSearchResults({
        data: result.filteredAccounts,
        totalFetched: result.filteredAccounts.length,
        totalPages: result.totalPages,
        currentPage: result.lastPage,
        hasMore: result.hasMore
      });

      // Scroll to results for better UX
      scrollToResults();

      // Hide toast and show success message
      hideToast();
      setTimeout(() => showToast(`✅ Found ${result.filteredAccounts.length} matching account(s)!`, 3000), 300);

    } catch (err) {
      console.error('Search failed:', err);

      // Check if it's a timeout error
      const isTimeout = err.message && err.message.includes('TIMEOUT');

      if (isTimeout) {
        resultsEl.innerHTML = '<div class="no-data">⏱️ The game server is taking too long to respond.<br><br>This usually means the server is experiencing high load or connectivity issues.<br><br>Please try again in a few moments.</div>';
        hideToast();
        setTimeout(() => showToast('⏱️ Server timeout. Please try again in a moment.', 4000), 300);
      } else {
        resultsEl.innerHTML = '<div class="no-data">❌ Search failed. Please try again.</div>';
        hideToast();
        setTimeout(() => showToast('❌ Search failed. Please try again.', 3000), 300);
      }
    } finally {
      // Re-enable search button
      const searchBtn = document.querySelector("#searchBtn");
      if (searchBtn) {
        searchBtn.disabled = false;
        searchBtn.textContent = 'Search';
      }
    }
  }

  function renderSearchResults(data) {
    const resultsEl = document.querySelector("#results");
    if (!resultsEl) return;

    if (!data.data || !data.data.length) {
      resultsEl.innerHTML = '<div class="no-data">No matching accounts found.</div>';
      return;
    }

    const accounts = data.data;
    const hasMore = data.hasMore || false;
    const currentPageNum = data.currentPage || 0;
    const totalPagesNum = data.totalPages || 0;

    // console.log('=== RENDERING RESULTS ===');
    // console.log(`Rendering ${accounts.length} accounts`);
    // accounts.forEach((acc, i) => {
    //   console.log(`Account ${i + 1}: ${acc.code}, ${acc.role_img?.length || 0} chars, first img: ${acc.role_img?.[0]?.img?.substring(0, 100) || 'none'}`);
    // });

    let headerText = `Showing ${accounts.length} matching account(s)`;

    let html = `<div class="results-header">${headerText}</div>`;

    accounts.forEach(account => {
      // Get character thumbnails for this account with names (apply translations)
      // Group characters by name and count duplicates
      const roleImgs = account.role_img || [];
      const charCounts = {};
      const charData = {};

      roleImgs.forEach(char => {
        const name = char.name;
        if (!charCounts[name]) {
          charCounts[name] = 0;
          charData[name] = char;
        }
        charCounts[name]++;
      });

      // Create array of unique characters with counts
      const uniqueChars = Object.keys(charCounts).map(name => ({
        ...charData[name],
        count: charCounts[name]
      }));

      // Sort: Characters first, then weapons
      const sortedChars = sortCharacters(uniqueChars);
      const characterThumbs = sortedChars.map(char => {
        const displayName = translateName(char.name);
        const customImg = getCustomImage(char.name);
        const displayImg = customImg || char.img;
        const count = char.count || 1;

        return `<div class="char-item">
          <img src="${escapeHtml(displayImg)}" alt="${escapeHtml(displayName)}" title="${escapeHtml(displayName)}" class="char-thumb" loading="lazy"/>
          <div class="char-label">${escapeHtml(displayName)}</div>
          ${count > 1 ? `<div class="char-count">x${count}</div>` : ''}
        </div>`;
      }).join('');

      html += `
        <div class="result-card">
          <div class="result-header">
            <div class="result-id">
              <strong>Account ID:</strong> ${escapeHtml(privateToPublicID(account.code || ''))}
            </div>
            <button class="copy-btn" onclick="copyToClipboard('${escapeHtml(privateToPublicID(account.code || ''))}')">Copy ID</button>
          </div>
          <div class="result-body">
            <div class="result-info">
              <div class="result-detail"><strong>Count:</strong> ${account.user_role_number || 0} total</div>
              <div class="result-detail"><strong>Server:</strong> ${escapeHtml(translateServer(account.district) || 'N/A')} | ZZZ01</div>
            </div>
            <div class="character-grid">
              ${characterThumbs}
            </div>
          </div>
        </div>
      `;
    });

    // Add "Load More" button if there are more pages to search
    if (hasMore) {
      html += `
        <div style="text-align: center; margin: 20px 0;">
          <button id="loadMoreBtn" class="btn primary" style="padding: 12px 24px;">
            Load More Results
          </button>
        </div>
      `;
    }

    resultsEl.innerHTML = html;

    // Attach load more handler
    const loadMoreBtn = document.querySelector('#loadMoreBtn');
    if (loadMoreBtn) {
      loadMoreBtn.onclick = loadMoreAccounts;
    }
  }

  async function loadMoreAccounts() {
    if (isLoadingMore) {
      // console.log('Already loading more accounts...');
      return;
    }

    isLoadingMore = true;
    const loadMoreBtn = document.querySelector('#loadMoreBtn');
    if (loadMoreBtn) {
      loadMoreBtn.textContent = 'Loading...';
      loadMoreBtn.disabled = true;
    }

    // console.log('Loading more accounts...');

    try {
      const selectedCodes = Object.keys(selected);
      const result = await fetchNextBatch(currentSearchParams, selectedCodes, currentSelectedServer, ACCOUNTS_PER_BATCH, true);

      if (result.filteredAccounts.length === 0) {
        // console.log('No more matching accounts found');
        if (loadMoreBtn) loadMoreBtn.parentElement.remove();
        isLoadingMore = false;
        return;
      }

      // Update state
      allFilteredAccounts.push(...result.filteredAccounts);
      currentPage = result.lastPage;
      totalPages = result.totalPages;

      // console.log(`Loaded ${result.filteredAccounts.length} more accounts. Total displayed: ${allFilteredAccounts.length}`);

      // Remove loading indicator
      const loadingDiv = document.querySelector('#loadMoreLoading');
      if (loadingDiv) loadingDiv.remove();

      // Append new accounts to existing results
      appendAccounts(result.filteredAccounts, result.hasMore);
    } catch (err) {
      console.error('Failed to load more accounts:', err);

      // Remove loading indicator
      const loadingDiv = document.querySelector('#loadMoreLoading');
      if (loadingDiv) loadingDiv.remove();

      // Check if it's a timeout error
      const isTimeout = err.message && err.message.includes('TIMEOUT');

      if (isTimeout) {
        showToast('⏱️ Server timeout while loading more. Please try again.', 4000);
      } else {
        showToast('❌ Failed to load more accounts. Please try again.', 3000);
      }

      if (loadMoreBtn) {
        loadMoreBtn.textContent = 'Load More Results';
        loadMoreBtn.disabled = false;
      }
    }

    isLoadingMore = false;
  }

  function appendAccounts(accounts, hasMore) {
    const resultsEl = document.querySelector("#results");
    if (!resultsEl) return;

    // Update header
    const headerEl = resultsEl.querySelector('.results-header');
    if (headerEl) {
      let headerText = `Showing ${allFilteredAccounts.length} matching account(s)`;
      headerEl.textContent = headerText;
    }

    // Remove old load more button if exists
    const oldLoadMoreBtn = resultsEl.querySelector('#loadMoreBtn');
    if (oldLoadMoreBtn) {
      oldLoadMoreBtn.parentElement.remove();
    }

    // Append new account cards
    let html = '';
    accounts.forEach(account => {
      // Group characters by name and count duplicates
      const roleImgs = account.role_img || [];
      const charCounts = {};
      const charData = {};

      roleImgs.forEach(char => {
        const name = char.name;
        if (!charCounts[name]) {
          charCounts[name] = 0;
          charData[name] = char;
        }
        charCounts[name]++;
      });

      // Create array of unique characters with counts
      const uniqueChars = Object.keys(charCounts).map(name => ({
        ...charData[name],
        count: charCounts[name]
      }));

      // Sort: Characters first, then weapons
      const sortedChars = sortCharacters(uniqueChars);
      const characterThumbs = sortedChars.map(char => {
        const displayName = translateName(char.name);
        const customImg = getCustomImage(char.name);
        const displayImg = customImg || char.img;
        const count = char.count || 1;

        return `<div class="char-item">
          <img src="${escapeHtml(displayImg)}" alt="${escapeHtml(displayName)}" title="${escapeHtml(displayName)}" class="char-thumb" loading="lazy"/>
          <div class="char-label">${escapeHtml(displayName)}</div>
          ${count > 1 ? `<div class="char-count">x${count}</div>` : ''}
        </div>`;
      }).join('');

      html += `
        <div class="result-card">
          <div class="result-header">
            <div class="result-id">
              <strong>Account ID:</strong> ${escapeHtml(privateToPublicID(account.code || ''))}
            </div>
            <button class="copy-btn" onclick="copyToClipboard('${escapeHtml(privateToPublicID(account.code || ''))}')">Copy ID</button>
          </div>
          <div class="result-body">
            <div class="result-info">
              <div class="result-detail"><strong>Count:</strong> ${account.user_role_number || 0} total</div>
              <div class="result-detail"><strong>Server:</strong> ${escapeHtml(translateServer(account.district) || 'N/A')} | ZZZ01</div>
            </div>
            <div class="character-grid">
              ${characterThumbs}
            </div>
          </div>
        </div>
      `;
    });

    // Add new load more button if there are more pages to search
    if (hasMore) {
      html += `
        <div style="text-align: center; margin: 20px 0;">
          <button id="loadMoreBtn" class="btn primary" style="padding: 12px 24px;">
            Load More Results
          </button>
        </div>
      `;
    }

    resultsEl.insertAdjacentHTML('beforeend', html);

    // Reattach load more handler
    const newLoadMoreBtn = document.querySelector('#loadMoreBtn');
    if (newLoadMoreBtn) {
      newLoadMoreBtn.onclick = loadMoreAccounts;
    }
  }

  document.querySelector("#clearBtn")?.addEventListener('click', clearSelection);
  document.querySelector("#searchBtn")?.addEventListener('click', performSearch);
  window.copyToClipboard = copyToClipboard;
  loadResources();
})();
